import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
import { accessNested, joinClasses } from 'utils/utils';
import { getIsSinglePageIframed } from 'utils/bolt/client';
import { getPercentageThreshold } from 'utils/visibilityChecks';
import Button from 'components/bolt/button/button';
import BurgerMenu from 'components/bolt/burgerMenu/burgerMenu';
import HeaderExpanded from 'components/bolt/header/headerExpanded';
// import { navigateInternally } from 'utils/bolt/index';
import { loadMap } from 'utils/bolt/loadMap';

import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {
	constructor(props) {
		super(props);
		this.state = { showReturnToMapButton: false };
		this.hasVisitedMap = false;
		this.triggerBurgerBtn = this.triggerBurgerBtn.bind(this);
		this.renderReturnToMapButton = this.renderReturnToMapButton.bind(this);
	}

	componentDidUpdate(prevProps) {
		const activePage = Store.get()?.activePage;
	
		if (activePage === 'map' && !this.hasVisitedMap) {
			this.hasVisitedMap = true;
			this.setState({ showReturnToMapButton: true });
		}
	}

	renderReturnToMapButton() {
		const copy = this.props.appData.pages.map?.data?.copy || {};
		const isOverlayOpen = this.props.headerData.showtimesOverlay || this.props.headerData.videoOverlayOpen;
		const videoOverlayOpen = this.props.headerData.videoOverlayOpen;

		return (
			<div 
				class={joinClasses(s.extraHeaderButton, isOverlayOpen && s.overlayOpen, videoOverlayOpen && s.videoOverlayOpen)}
				onClick={loadMap}
			>
				<div class={s.buttonWrapper}>
					<div class={s.circleFill} />
					<svg class={s.extraHeaderButtonIcon} fill="currentColor" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_1811_7951)">
							<path d="M1.3335 3.99992L0.961392 3.34874C0.727711 3.48227 0.583496 3.73078 0.583496 3.99992H1.3335ZM1.3335 14.6666H0.583496C0.583496 14.9339 0.725815 15.1811 0.957051 15.3153C1.18829 15.4495 1.47347 15.4504 1.7056 15.3178L1.3335 14.6666ZM10.6668 14.6666L10.2947 15.3178L11.0829 15.2906L10.6668 14.6666ZM14.6668 11.9999L15.0829 12.624C15.2915 12.4849 15.4168 12.2507 15.4168 11.9999H14.6668ZM14.6668 1.33325H15.4168C15.4168 1.05666 15.2646 0.80251 15.0207 0.671996C14.7769 0.541482 14.4809 0.555786 14.2508 0.709214L14.6668 1.33325ZM6.00016 1.33325L6.37227 0.68207H5.62806L6.00016 1.33325ZM0.583496 3.99992V14.6666H2.0835V3.99992H0.583496ZM1.7056 15.3178L6.37227 12.6511L5.62806 11.3487L0.961392 14.0154L1.7056 15.3178ZM5.62806 12.6511L10.2947 15.3178L11.0389 14.0154L6.37227 11.3487L5.62806 12.6511ZM11.0829 15.2906L15.0829 12.624L14.2508 11.3759L10.2508 14.0425L11.0829 15.2906ZM15.4168 11.9999V1.33325H13.9168V11.9999H15.4168ZM14.2508 0.709214L10.2508 3.37588L11.0829 4.62396L15.0829 1.95729L14.2508 0.709214ZM11.0389 3.34874L6.37227 0.68207L5.62806 1.98443L10.2947 4.6511L11.0389 3.34874ZM5.62806 0.68207L0.961392 3.34874L1.7056 4.6511L6.37227 1.98443L5.62806 0.68207ZM11.4168 14.6666V3.99992H9.91683V14.6666H11.4168ZM5.25016 1.33325V11.9999H6.75016V1.33325H5.25016Z"/>
						</g>
						<defs>
							<clipPath id="clip0_1811_7951">
								<rect width="16" height="16" fill="currentColor"/>
							</clipPath>
						</defs>
					</svg>
				</div>
				<span class={s.label}>{copy.map?.topNav?.returnToMap}</span>
			</div>
		);
	}

	componentDidMount() {
		Store.on('TRIGGER_BURGER_BTN', this.triggerBurgerBtn);
	}

	componentWillUnmount() {
		Store.off('TRIGGER_BURGER_BTN', this.triggerBurgerBtn);
	}

	render(props) {
		const {
			appData,
			activePage,
			headerData,
			isCalendarRemindMode,
			client,
			solidBackground,
			desktopSolidHeader,
			style,
			offsetTop,
			calRemindOpen
		} = props;
		const { copy } = appData;
		const copyMap = accessNested(Store.get(), 'appData.pages.map.data.copy' || {});
		const mapEnabled = appData?.pages?.map;
		const {
			showtimesOverlay,
			homeEntOverlay,
			pressKitOverlay,
			homeEntMerchantOpen,
			activeSection,
			videoOverlayOpen,
			showtimesSearchOverlay,
			open: navOpen,
			shareOpen,
			interstitialOpen,
			hubTextOverlayOpen,
		} = headerData || {};

		const store = Store.get();
		const isMobile = accessNested(this.props, 'client.device', '') !== 'desktop';
		const homeActive = isMobile ? activePage === 'boltHome' : store.homeActivePercentage ?? 1 > getPercentageThreshold(offsetTop);
		const nonMapActivePages = activePage === 'about' || activePage === 'boltGallery' || activePage === 'posters';

		const locationClassName = videoOverlayOpen ? 'boltVideos' : (activeSection || 'bolt');
		const actionData = this.getCurrentHeaderAction();

		const regionSelector = this.renderRegionSelector();
		const regionSelectorEnabled = typeof accessNested(appData, 'header.powsterHeader.regionSelector') !== 'undefined';
		// Should be set at studio level
		const { regionSelectorShowing } = this.state;

		const fontStyles = accessNested(this.props, 'appData.styling.fontVariables');

		const oneSheetOverlay = accessNested(store, 'synopsis.onesheetExpanded');
		// TODO: let trailerOverlay component itself handle hiding the burger menu if needed to better match the behaviour
		const trailerOverlayOpen = store.trailerOverlay?.overlayOpen && store.trailerOverlay?.data?.video;

		// const headerLogo = accessNested(appData, 'header.powsterHeader.logo', false);
		// const headerLogoExclusions = (headerLogo?.pageExclusions || '').split(',')?.map(e => e.trim())?.filter(e => e);
		// const hideHeaderLogo = headerLogoExclusions.includes(store.activePage);
		const hideBurgerMenu = accessNested(Store.get(), 'appData.options.disableBurgerMenu', false);
		const isDesktopSize = accessNested(this.props, 'client.isDesktopSize');


		let containerStyle = {};
		if (offsetTop) {
			containerStyle.top = offsetTop + 'px';
		}

		let sonyHeader = this.renderSonyHeader();

		if (!accessNested(this.props, 'appData.header.powsterHeader')) {
			return sonyHeader;
		}

		let burgerMenuAriaLabel;

		// Should probably set the Aria label when setting the action (when calling SET_HEADER_ACTION)
		if (actionData.icon === 'burger') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$OPEN_NAV_ARIA;
		} else if (actionData.tag === 'closeNavMenu') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$CLOSE_NAV_ARIA;
		} else if (actionData.tag === 'closeOnesheetOverlay') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$CLOSE_ONESHEET_ARIA;
		} else if (actionData.tag === 'closeCalRemind') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$CALENDAR_REMINDER_CLOSE_ARIA;
		} else if (actionData.tag === 'closeVideoOverlay') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$CLOSE_VIDEOS_ARIA;
		} else if (actionData.icon === 'back') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$BACK_BTN_SHOWTIMES_ARIA;
		}

		const navDisabled = !this.props?.appData?.header?.powsterHeader?.nav;
		const isSinglePageIframed = getIsSinglePageIframed();
		const menuText = copy.baseCopy.$NAVIGATION_LABEL;
		const showMenuText = menuText && !showtimesOverlay && !homeEntOverlay && !videoOverlayOpen && !navDisabled;
		const providerInterstitialOpen = accessNested(store, 'showtimes.providerInterstitialOpen', false) || accessNested(store, 'previewPanel.providerInterstitialOpen', false);

		const sectionSpecificStyle = this.getSectionSpecificStyle();
		const navLabelStyle = {};
		if (sectionSpecificStyle) {
			const { headerNavLabel } = sectionSpecificStyle;
			navLabelStyle.color = headerNavLabel;
		}

		const burgerStyle = {};
		if (sectionSpecificStyle && !headerData.open) {
			const { headerNavIconOpen, headerNavIconOpenMob } = sectionSpecificStyle;
			burgerStyle.background = (headerNavIconOpenMob && !isDesktopSize) ? headerNavIconOpenMob : headerNavIconOpen;
		}

		const isBurgerIcon = !actionData.icon || actionData.icon === 'burger';
		const customBurgerMenu = accessNested(store, 'appData.header.powsterHeader.customBurgerMenu', null);

		return (
			<div
				class={joinClasses(`header-${activePage}`, navOpen && 'navOpen', {
					s,
					headerContainer: true,
					homeEntMerchantOpen,
					iframe: isSinglePageIframed
				})}
			>
				{sonyHeader}
				<div
					class={
						joinClasses({
							s,
							container: true,
							showtimesSearchOverlay,
							solidBackground,
							mapEnabled,
							desktopSolidHeader,
							hubTextOverlayOpen,
						}, s[`activeSection--${locationClassName}`])
					}
					style={containerStyle}
					key="container"
					id="header"
				>
					<div class={joinClasses(s.navContainer, showtimesOverlay && s.showtimesOverlay, videoOverlayOpen && s.videoOverlayOpen)}>
						<div class={s.burgerContainer}>
							<Button
								class={joinClasses(
									s.burgerMenuBtn,
									(shareOpen || regionSelectorShowing || navDisabled || providerInterstitialOpen || (hideBurgerMenu && isBurgerIcon)) && s.hide,
									isSinglePageIframed && s.disabled
								)}
								trigger={(videoOverlayOpen) ? loadMap : this.triggerBurgerBtn}
								ariaLabel={burgerMenuAriaLabel}
								key="burgerButton"
							>
								<BurgerMenu
									type={actionData.icon || 'burger'}
									dark={actionData.dark}
									style={actionData.style}
									hidden={interstitialOpen}
									lineStyle={burgerStyle}
									showtimesOverlayOpen={showtimesOverlay}
									homeEntOverlayOpen={homeEntOverlay}
									pressKitOverlayOpen={pressKitOverlay}
									isSinglePageIframed={isSinglePageIframed}
									homeScrolled={!homeActive}
									navOpen={navOpen}
									showtimesSearchOverlay={showtimesSearchOverlay}
									videoOverlayOpen={videoOverlayOpen}
									oneSheetOverlayOpen={oneSheetOverlay}
									trailerOverlayOpen={trailerOverlayOpen}
									calendarRemindOpen={calRemindOpen}
									widgetFullyExpanded={store.widgetFullyExpanded}
									customBurgerMenu={!showtimesSearchOverlay ? customBurgerMenu : null}
								/>
							</Button>
							{activePage !== 'map' && <span class={s.burgerLabel}>{(navOpen || videoOverlayOpen) ? copyMap?.map?.topNav?.close : copyMap?.map?.topNav?.menu}</span>}
						</div>
						{(this.state.showReturnToMapButton || nonMapActivePages || videoOverlayOpen || showtimesOverlay && mapEnabled) && this.renderReturnToMapButton()}
					</div>
					{!showtimesOverlay && this.renderHeaderLogo()}
					{!!showMenuText && (
						<span class={joinClasses(s.menuText, fontStyles.headerShare, { s, homeScrolled: !homeActive })} style={navLabelStyle} onClick={this.triggerBurgerBtn}>
							{menuText}
						</span>
					)}
					{this.renderExtraActions()}
					{!showtimesOverlay && this.renderPersistentButton()}
					{this.renderShare()}
					<HeaderExpanded
						appData={appData}
						activePage={activePage}
						headerData={headerData}
						navOpen={navOpen}
						client={client}
						isCalendarRemindMode={isCalendarRemindMode}
						showRegionSelector={regionSelector && regionSelectorEnabled}
						regionSelectorClick={this.toggleRegionSelector}
						style={style}
						key="expand"
					/>
					{regionSelector}
				</div>
			</div>
		);
	}
}